// extracted by mini-css-extract-plugin
module.exports = {"horizontalDivider":"HorizontalDivider_horizontalDivider__FzJQ9","shimmer":"HorizontalDivider_shimmer__kAOmK"};